/* AMAYAAH theme — interactions + Shopify AJAX cart */
(function(){
  var intro = document.querySelector('.intro');
  if(intro){
    if(sessionStorage.getItem('amayaah_seen')){ intro.remove(); }
    else{
      document.body.style.overflow='hidden';
      setTimeout(function(){
        intro.classList.add('hide'); document.body.style.overflow='';
        sessionStorage.setItem('amayaah_seen','1');
        setTimeout(function(){ if(intro) intro.remove(); },900);
      },2600);
    }
  }

  var header = document.querySelector('.header.transparent');
  function onScroll(){ if(!header) return; header.classList.toggle('scrolled', window.scrollY>60); }
  window.addEventListener('scroll', onScroll, {passive:true}); onScroll();

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });
  },{threshold:.14, rootMargin:'0px 0px -8% 0px'});
  document.querySelectorAll('[data-reveal]').forEach(function(el,i){ el.style.transitionDelay=(i%4)*0.08+'s'; io.observe(el); });

  var burger=document.querySelector('.burger'), mnav=document.querySelector('.mobile-nav');
  if(burger&&mnav){
    burger.addEventListener('click',function(){mnav.classList.add('open');document.body.style.overflow='hidden';});
    var c=mnav.querySelector('.close'); if(c) c.addEventListener('click',function(){mnav.classList.remove('open');document.body.style.overflow='';});
    mnav.querySelectorAll('a').forEach(function(a){a.addEventListener('click',function(){mnav.classList.remove('open');document.body.style.overflow='';});});
  }

  // Collection filter (if present on page)
  var fbtns=document.querySelectorAll('.filterbar button');
  fbtns.forEach(function(btn){
    btn.addEventListener('click',function(){
      fbtns.forEach(function(b){b.classList.remove('active');}); btn.classList.add('active');
      var f=btn.dataset.filter;
      document.querySelectorAll('.products .product').forEach(function(p){
        p.style.display=(f==='all'||(p.dataset.cat||'').indexOf(f)>-1)?'':'none';
      });
    });
  });

  // Shopify AJAX add to cart
  function refreshCart(){
    fetch('/cart.js').then(function(r){return r.json();}).then(function(c){
      document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=c.item_count;});
    }).catch(function(){});
  }
  document.addEventListener('submit', function(e){
    var form = e.target.closest('form[action^="/cart/add"], form.product-add-form');
    if(!form) return;
    e.preventDefault();
    var btn = form.querySelector('[type=submit]'); var label = btn ? btn.textContent : '';
    var data = new FormData(form);
    if(btn) btn.textContent='Adding…';
    fetch('/cart/add.js',{method:'POST',body:data,headers:{'Accept':'application/json'}})
      .then(function(r){return r.json();})
      .then(function(){ if(btn){btn.textContent='Added ✓'; setTimeout(function(){btn.textContent=label;},1500);} refreshCart(); })
      .catch(function(){ if(btn) btn.textContent=label; });
  });
  refreshCart();
})();
